import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dms, OpStatus } from 'NSwag/ServerClient/Client.nswag';
import { Typography } from '@material-ui/core';
import MultiMsgDisplay from 'Common/Controls/Dms/MultiMsg/MultiMsgDisplay';

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: '#ffffff',
        padding: theme.spacing(2),
        borderRadius: 5
    }
}));

interface IProps {
    dms: Dms;
}

const DmsTooltip = ({ dms }: IProps) => {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Typography variant="body1">
                {dms.displayName}
            </Typography>
            <div>
                <MultiMsgDisplay
                    multiMsg={dms.status!.multiMsg!}
                    opStatus={dms.status!.intOpStatus as OpStatus}
                    dmsConfig={dms.dmsConfig}
                    font={null}
                />
            </div>
        </div>
    );
};

export default DmsTooltip;